<script setup>
import { normalizeClass, useAttrs } from 'vue';
import Input from 'dashboard/components-next/input/Input.vue';

const props = defineProps({
  label: { type: String, default: '' },
  modelValue: { type: [String, Number], default: '' },
  type: { type: String, default: 'text' },
  placeholder: { type: String, default: '' },
  helpText: { type: String, default: '' },
  error: { type: String, default: '' },
  readonly: { type: Boolean, default: false },
});
const emit = defineEmits(['update:modelValue', 'input', 'blur']);
defineOptions({ inheritAttrs: false });
const attrs = useAttrs();

// Read attrs during render: legacy callers can toggle only the error class.
const hasError = () =>
  Boolean(props.error) ||
  normalizeClass(attrs.class).split(/\s+/).includes('error');
const inputAttrs = () => ({
  ...attrs,
  class: [
    'mb-4',
    normalizeClass(attrs.class)
      .split(/\s+/)
      .filter(name => name !== 'error'),
  ],
});

// Keep the legacy string payloads, including number fields and empty values.
const onInput = event => {
  emit('input', event.target.value);
  emit('update:modelValue', event.target.value);
};
</script>

<template>
  <Input
    v-bind="inputAttrs()"
    :model-value="modelValue"
    :type="type"
    :label="label"
    :placeholder="placeholder"
    :readonly="readonly"
    :message="error || helpText"
    :message-type="hasError() ? 'error' : 'info'"
    @input="onInput"
    @blur="emit('blur', $event.target.value)"
  >
    <template v-if="$slots.masked" #suffix>
      <slot name="masked" />
    </template>
  </Input>
</template>
